import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaFileAlt } from 'react-icons/fa';
import config from '../config/config';

const DocumentButton = ({ veiculo, onClick }) => {
    const [documentCount, setDocumentCount] = useState(0);

    const getAuthHeader = () => {
        const token = localStorage.getItem('jwtToken');
        return {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        };
      };
      const { API_BASE_URL } = config;
    useEffect(() => {
      const fetchDocumentCount = async () => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/arquivos/veiculo/${veiculo.idVeiculo}/count`,
            getAuthHeader()
          );
          setDocumentCount(response.data.count);
        } catch (error) {
          console.error('Erro ao contar documentos:', error);
        }
      };
  
      fetchDocumentCount();
    }, [veiculo.idVeiculo]);
  
    return (
      <button
        onClick={onClick}
        style={{
          ...styles.documentButton,
          ...(documentCount > 0 && styles.documentButtonWithFiles)
        }}
      >
        <FaFileAlt />
        Documentos
        {documentCount > 0 && (
          <span style={styles.documentCountBadge}>
            {documentCount}
          </span>
        )}
      </button>
    );
  };
  const styles = {
    documentButton: {
        padding: '8px 12px',
        backgroundColor: '#3498db', // Cor padrão
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '13px',
        fontWeight: '600',
        transition: 'all 0.3s',
        position: 'relative',
        '&:hover': {
          backgroundColor: '#2980b9'
        }
      },
      documentButtonWithFiles: {
        backgroundColor: '#2ecc71', // Cor quando tem arquivos
        '&:hover': {
          backgroundColor: '#27ae60'
        }
      },
      documentCountBadge: {
        position: 'absolute',
        top: '-8px',
        right: '-8px',
        backgroundColor: '#e74c3c',
        color: 'white',
        borderRadius: '50%',
        width: '18px',
        height: '18px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '10px',
        fontWeight: 'bold'
      }
  }

  export default DocumentButton;